module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "label-width": "180px"
    }
  }, [_c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "销售下单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "发货通知单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendCode))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "发货通知单状态"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendStatusName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "代理商"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AgentCode) + _vm._s(_vm.Form.AgentName) + " " + _vm._s(_vm.Form.AgentAddress) + " " + _vm._s(_vm.Form.AgentTel))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "发货通知单下单时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendTime))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "发货通知单下单人"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AddUserName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "发货情况"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.DeliveryStatusName))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.ListGoods != ''),
      expression: "Form.ListGoods!=''"
    }],
    staticClass: "edit-form",
    staticStyle: {
      "width": "900px"
    },
    attrs: {
      "label": "商品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "25px"
    },
    attrs: {
      "data": _vm.Form.ListGoods,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProductNum",
      "label": "订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "SendNum",
      "label": "通知数"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.GiftGoods != ''),
      expression: "Form.GiftGoods!=''"
    }],
    staticClass: "edit-form",
    staticStyle: {
      "width": "900px"
    },
    attrs: {
      "label": "赠品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "25px"
    },
    attrs: {
      "data": _vm.Form.GiftGoods,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProductNum",
      "label": "订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "SendNum",
      "label": "通知数"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "要求发货时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.RequireSendDate))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "发货通知单审核时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AuditTime))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "收货地址"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AgentConsignee))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "收货人及联系方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.Consignee) + "--" + _vm._s(_vm.Form.ConsigneeTel))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "寄送方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendModeName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "支付方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.PayModeName))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a8daa202!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SendGoods/AuditViewSendGoods.vue
// module id = 1551
// module chunks = 1